import { render, staticRenderFns } from "./LeftNavBar.vue?vue&type=template&id=883e00bc&scoped=true&"
import script from "./LeftNavBar.vue?vue&type=script&lang=js&"
export * from "./LeftNavBar.vue?vue&type=script&lang=js&"
import style0 from "./LeftNavBar.vue?vue&type=style&index=0&id=883e00bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "883e00bc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
installComponents(component, {VBtn,VDivider,VIcon,VNavigationDrawer})
